import { render, staticRenderFns } from "./TsOrgTree.vue?vue&type=template&id=c510b956&"
import script from "./TsOrgTree.vue?vue&type=script&lang=js&"
export * from "./TsOrgTree.vue?vue&type=script&lang=js&"
import style0 from "./TsOrgTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports